import { useViewportSize } from '@ole-ui/ole-ui-components';
import { Alert } from '@patternfly/react-core';
import React from 'react';
import { useTranslation } from 'react-i18next';

const LabEnvironmentMobileAlert = () => {
  const { isLowerThanMd: isMobileMode } = useViewportSize();
  const { t } = useTranslation();

  if (!isMobileMode) {
    return null;
  }

  return (
    <Alert
      isInline
      variant="info"
      title={t('Get the best lab experience')}
      style={{ marginBottom: 'var(--pf-v5-global--spacer--md)' }}
    >
      <p>
        {t(
          'For an optimal experience on mobile and tablet devices, we recommend using an external keyboard. While the lab environment is accessible on smaller screens, it is best experienced on larger displays.',
        )}
      </p>
    </Alert>
  );
};

export default LabEnvironmentMobileAlert;
